import { ModalConfig } from '@/models/ModalConfig';
import { ApplicationState } from '@/store';
import { closeModal } from '@/store/common/actions';
import React, { useCallback, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface Props {
    modalId: string;
}

const NullModal = { id: '', isCloseAllowed: true, isVisible: false, layoutModal: null };

const MoreOptionsModal: React.FC<Props> = ({ modalId }: Props) => {
    const { id, isCloseAllowed, isVisible, layoutModal } = useSelector((state: ApplicationState) => {
        const modal = state.common.modal && state.common.modal[modalId];
        return Boolean(modal) ? { ...modal } : NullModal;
    }) as ModalConfig;

    const dispatch = useDispatch();

    const dismissModalHandler = () => {
        dispatch(closeModal(id as string));
    };

    const escFunction = useCallback(
        (event: KeyboardEvent) => {
            if (!isCloseAllowed) {
                return;
            }
            if (event.keyCode === 27) {
                dismissModalHandler();
            }
        },
        [dismissModalHandler],
    );

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [escFunction]);

    return (
        <Modal
            backdrop={isCloseAllowed ? true : 'static'}
            centered
            className="more-options-modal"
            id={id}
            keyboard={false}
            onHide={() => dismissModalHandler()}
            show={isVisible}
        >
            {layoutModal}
        </Modal>
    );
};

export default MoreOptionsModal;
